module.exports = __webpack_public_path__ + "static/img/step-2.6a5952a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/step-2.png
// module id = ydxe
// module chunks = 1